import type { ReactNode } from 'react'
import type { StyleProp, ViewStyle } from 'react-native'
import { StyleSheet, View } from 'react-native'

type CardVariant = 'elevated' | 'dashboard'

interface CardProps {
  children: ReactNode
  className?: string
  style?: StyleProp<ViewStyle>
  variant?: CardVariant
}

export function Card({ children, className, style, variant = 'elevated' }: CardProps) {
  const variantClassName =
    variant === 'dashboard'
      ? 'rounded-md border border-border bg-canvas-card'
      : 'rounded-xl bg-canvas-card'
  const variantStyle = variant === 'dashboard' ? styles.dashboard : styles.elevated

  return (
    <View className={`${variantClassName} ${className ?? ''}`} style={[variantStyle, style]}>
      {children}
    </View>
  )
}

const styles = StyleSheet.create({
  elevated: {
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 28,
    elevation: 3,
  },
  dashboard: {
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.03,
    shadowRadius: 12,
    elevation: 1,
  },
})
